module.exports = require('./helpers/bundle-url').getBundleURL('ucbwC') + "logo.7718c6df.svg";